import React from 'react';
import { themes } from 'kb-shared';
const DEFAULT_PROPS = {
  color: themes.colors.KBYellow
};

const LocationPinIcon = (props: { color: string } = DEFAULT_PROPS) => {
  return (
    <svg
      width="25px"
      height="43px"
      viewBox="0 0 25 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile-Portrait"
          transform="translate(-40.000000, -329.000000)"
          fill={props.color || DEFAULT_PROPS.color}
        >
          <g id="Appointment-Module" transform="translate(23.000000, 171.000000)">
            <path
              d="M30.4227266,200.389563 L40.18602,177.196903 L40.1886508,177.191039 L40.7503114,175.832514 C40.7647805,175.795374 40.7772764,175.758886 40.7831956,175.722398 C43.0015579,171.119051 42.1866895,165.439309 38.3385905,161.626969 C33.4572726,156.79101 25.5440394,156.79101 20.6620639,161.626969 C16.8415875,165.411291 16.0102771,171.034347 18.1687904,175.620102 C18.1740518,175.639649 18.1793133,175.659196 18.1878631,175.678091 L18.6219335,176.755138 L18.6278526,176.768821 L28.5772701,200.389563 C28.7910169,200.895182 29.3756964,201.133657 29.8860579,200.923851 C30.1280849,200.822206 30.3214435,200.630644 30.4227266,200.389563 M33.036356,166.881235 C34.9896724,168.815748 34.9896724,171.951758 33.036356,173.886923 C31.0830396,175.820785 27.9162994,175.820785 25.9642984,173.886923 C24.0109821,171.951758 24.0109821,168.815748 25.9642984,166.881235 C27.9162994,164.945418 31.0830396,164.945418 33.036356,166.881235"
              id="Location-Icon"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LocationPinIcon;
